import { isNullOrUndefined, hasValue } from "../../../../../general/js/general-helpers";

export const shouldDisplayResaleButton = (buttonCriteria = null, ballotCriteria = null, membership = null) => {
    var showResaleButton = false;

    if( isNullOrUndefined(membership) || !hasValue(buttonCriteria)) return showResaleButton;

    const userMemberships = membership.toLowerCase().split(';').filter(m => m);;
    const criteriaList = buttonCriteria.toLowerCase().split(';').filter(criterion => criterion);

    if ( hasValue(ballotCriteria) ) {
        if (criteriaList.includes(ballotCriteria.toLowerCase())) {
            showResaleButton = true;
        }
    }

    criteriaList.every(criterion => {
        if(userMemberships.includes(criterion.toLowerCase())){
            showResaleButton = true;
            return false;
        }

        return true;
    });

    return showResaleButton;
};

export const shouldDisplayResaleSection = (buyButtonCriteria = null, sellButtonCriteria = null, ballotCriteria = null, membership = null) => {
    const showBuyLink = shouldDisplayResaleButton(buyButtonCriteria, ballotCriteria, membership);
    const showSellLink = shouldDisplayResaleButton(sellButtonCriteria, ballotCriteria, membership);

    return showBuyLink || showSellLink;
};